import React from 'react';
import { Clock, Mail, LogOut } from 'react-feather';
import { useAuth } from '../contexts/AuthContext';
import './PendingApprovalScreen.css';

export const PendingApprovalScreen: React.FC = () => {
  const { signOut, user } = useAuth();

  const handleSignOut = async () => {
    await signOut();
  };

  return (
    <div className="pending-screen">
      <div className="pending-container">
        <div className="pending-icon">
          <Clock size={48} />
        </div>
        
        <h1>Application Under Review</h1>
        
        <p className="pending-message">
          Thank you for registering with TowApp! Our admin team is currently reviewing your application.
        </p>
        
        <div className="pending-info">
          <div className="info-item">
            <Mail size={18} />
            <span>We'll notify you at</span>
            <strong>{user?.email}</strong>
          </div>
        </div>

        <div className="pending-timeline">
          <div className="timeline-item completed">
            <div className="timeline-dot"></div>
            <div className="timeline-content">
              <span className="timeline-title">Account Created</span>
              <span className="timeline-desc">Your account has been set up</span>
            </div>
          </div>
          
          <div className="timeline-item completed">
            <div className="timeline-dot"></div>
            <div className="timeline-content">
              <span className="timeline-title">Email Verified</span>
              <span className="timeline-desc">Your email has been confirmed</span>
            </div>
          </div>
          
          <div className="timeline-item active">
            <div className="timeline-dot"></div>
            <div className="timeline-content">
              <span className="timeline-title">Pending Approval</span>
              <span className="timeline-desc">Waiting for admin review</span>
            </div>
          </div>
          
          <div className="timeline-item">
            <div className="timeline-dot"></div>
            <div className="timeline-content">
              <span className="timeline-title">Access Granted</span>
              <span className="timeline-desc">Start using TowApp</span>
            </div>
          </div>
        </div>

        <p className="pending-note">
          This usually takes 1-2 business days. If you have any questions, please contact our support team.
        </p>

        <button className="signout-button" onClick={handleSignOut}>
          <LogOut size={18} />
          Sign Out
        </button>
      </div>
    </div>
  );
};


